import { render, staticRenderFns } from "./DetailLeft.vue?vue&type=template&id=012037e2&scoped=true&"
import script from "./DetailLeft.vue?vue&type=script&lang=js&"
export * from "./DetailLeft.vue?vue&type=script&lang=js&"
import style0 from "./DetailLeft.vue?vue&type=style&index=0&id=012037e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012037e2",
  null
  
)

export default component.exports